<!--
 * @Author: 仙道
 * @Date: 2022-12-11 23:19:13
 * @LastEditTime: 2022-12-11 23:32:02
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/layouts/iframeReportView.vue
-->
<template>
  <div class="iframe-container">
    <iframe
      :id="`report${keys}`"
      :src="url"
      :style="{ height: iframeContainerHeight }"
      allowfullscreen="true"
      frameborder="0"
      mozallowfullscreen="true"
      msallowfullscreen="true"
      oallowfullscreen="true"
      ref="commentIframe"
      webkitallowfullscreen="true"
    />
  </div>
</template>


<script>
  import { mixin, mixinDevice } from '@/utils/mixin.js'

  export default {
    name: 'iframeReportView',
    components: {

    },
    mixins: [mixin, mixinDevice],
    props: ['url', 'keys'],
    // 定义属性
    data () {
      return {

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      iframeContainerHeight () {
        let deductHeight = 0

        // Header高度 (来自GlobalHeader组件)
        const headerHeight = 64

        // 多页签高度 (来自TabLayout组件的a-tabs，style="height:52px")
        const tabHeight = this.multipage ? 52 : 2

        // 根据布局模式计算不同的高度
        if (this.layoutMode === 'topmenu') {
          // 顶部菜单模式：可能需要额外减去顶部菜单的高度
          const fixedTopMenuHeight = 0 // 根据实际情况调整，如果顶部菜单有额外高度
          deductHeight = headerHeight + tabHeight + fixedTopMenuHeight
        } else {
          // 侧边菜单模式 (sidemenu)：只需要减去header和tab高度
          deductHeight = headerHeight + tabHeight
        }

        return `calc(100vh - ${deductHeight}px)`
      }
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='scss' scoped>

  .iframe-container {
    iframe {
      width: 100%;
    }
    .el-loading-spinner {
      left: 50%;
      text-align: left !important;
    }
    background: #fff;
  }

</style>